import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";

import { IconButton } from "@mui/material";
import { SecurityIcon, UserGrantEditIcon, VisibilityIcon } from "components/Icons/Icons";

import { TilleyCard } from "../../Cards/TilleyCard";

const PERMISSION_STATUS = {
  NONE: 0,
  PARTIAL: 1,
  FULL: 2,
};

const getPermissionStatus = (isMaster, items, permissionType) => {
  if (isMaster) return PERMISSION_STATUS.FULL;
  return items?.find((item) => item[permissionType]) ? PERMISSION_STATUS.PARTIAL : PERMISSION_STATUS.NONE;
};

export default function UserGrantCard({ userGrant, userGrantItems }) {
  const { producer_token } = useParams();

  const navigate = useNavigate();

  const [permissionStatus, setPermissionStatus] = useState({
    is_read: PERMISSION_STATUS.NONE,
    is_write: PERMISSION_STATUS.NONE,
    is_delete: PERMISSION_STATUS.NONE,
  });

  useEffect(() => {
    setPermissionStatus({
      is_read: getPermissionStatus(userGrant.is_master_read, userGrantItems, "is_read"),
      is_write: getPermissionStatus(userGrant.is_master_write, userGrantItems, "is_write"),
      is_delete: getPermissionStatus(userGrant.is_master_delete, userGrantItems, "is_delete"),
    });
  }, [userGrant, userGrantItems]);

  return (
    <>
      <TilleyCard
        data-testid="userGrantSharing"
        onClick={() => navigate(`/userGrant/${producer_token}/${userGrant?.id}`)}
        Avatar={SecurityIcon}
        title={userGrant?.user_description}
        subtitle={""}
        action={
          <>
            {permissionStatus?.is_read !== PERMISSION_STATUS.NONE && (
              <IconButton
                onClick={(e) => {
                  e.stopPropagation();
                }}
              >
                <VisibilityIcon />
              </IconButton>
            )}
            {permissionStatus?.is_write !== PERMISSION_STATUS.NONE && (
              <IconButton
                onClick={(e) => {
                  e.stopPropagation();
                }}
              >
                <UserGrantEditIcon />
              </IconButton>
            )}
          </>
        }
        footer={""}
      />
    </>
  );
}
